import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'cart-add_to_cart_web_cuj-click';

/**
 * add to cart web CUJ
 */
export function trackCartAddToCartWebCujClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}

/**
 * Trace for event: cart-add_to_cart_web_cuj-click
 */
export function trackCartAddToCartWebCujClickTraceUalComplete(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'cart-add_to_cart_web_cuj-click-trace-ual_complete',
    realTimeTracking: false,
    sourceEventKey: 'cart-add_to_cart_web_cuj-click',
    sourceEventMarker,
  });
}

/**
 * Trace for event: cart-add_to_cart_web_cuj-click
 */
export function trackCartAddToCartWebCujClickTraceUpdateCartApiCallComplete(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey:
      'cart-add_to_cart_web_cuj-click-trace-update_cart_api_call_complete',
    realTimeTracking: false,
    sourceEventKey: 'cart-add_to_cart_web_cuj-click',
    sourceEventMarker,
  });
}
